import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { ITag, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const TAGS_ROOT = ['tags'] as const;

interface TagsSearchParams {
    projectId: number;
    tagCategoryId?: number;
    sceneId?: number;
    query?: string;
    version?: string;
}

const fetchers = {
    search: {
        key: (args: TagsSearchParams) => [...TAGS_ROOT, 'search', args] as const,
        fetch: async ({ projectId, tagCategoryId, sceneId, query, version }: TagsSearchParams): Promise<ITag[]> => {
            const searchParams = new URLSearchParams();
            if (query) searchParams.set('query', query);
            if (sceneId) searchParams.set('scenes[]', String(sceneId));
            if (tagCategoryId) searchParams.set('tag_category_id', String(tagCategoryId));
            if (version) searchParams.set('version', version);
            const qs = searchParams.toString();
            const url = `projects/${projectId}/tags${qs ? `?${qs}` : ''}`;
            const response: ResponseType<ITag[]> = await request(url);
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const tagsEntity: EntityDefinition<typeof fetchers> = {
    name: 'tags',
    roots: [TAGS_ROOT],
    fetchers,
};

export const useTagsSearch = createEntityQuery(tagsEntity, 'search');

export type { TagsSearchParams };
